<template>
  <div class="container detail" v-html="language=== 'en' ? datas.enContent : language=== 'fr' ? datas.enContent : datas.content"></div>
</template>
<script>
import { mapState } from 'vuex'
import { getCompanyInfo } from '@/api/home'

export default {
  name: 'pageDetail',
  data() {
    return {
      datas: {}
    }
  },
  computed: {
    ...mapState('operate', ['language'])
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 获取公司简介
      getCompanyInfo().then(res => {
        if (res.success) {
          this.datas = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.detail {
  padding: 40px 0;

  & img {
    max-width: 100%;
  }
}
</style>
